// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2sHub","signatureButtonsRight":"ModalSign_signatureButtonsRight__dVh-P"};